module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-7011HD_white-6b2b2238fce339bf7e6aca831308890d.png";